module.exports = __webpack_public_path__ + "static/media/datazip-logo.c7df957c.svg";